import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts.css';
import './index.css';
import App from './App';
import UpdateBanner from './components/UpdateBanner';
import DevGate from './components/DevGate';
import reportWebVitals from './reportWebVitals';
import './i18n/i18n';
import { isNative, nativeReady, startNative } from './platform/native';
// Ensure platform adapters are initialized (currently storageAdapter is defaulted in storageService).

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// In the iOS/Android apps: put back a cleared login and set up the native listeners first.
void startNative().finally(() => {
  root.render(
    <React.StrictMode>
      <DevGate>
        <App />
        {/* "A new version is ready" on every screen, also the member chooser on the family tablet.
            The apps carry their own copy of the web app and update through the stores instead. */}
        {!isNative && <UpdateBanner />}
      </DevGate>
    </React.StrictMode>
  );
  void nativeReady();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
